<template>
  <v-container fluid>
    <base-material-card
      color="primary" 
      icon="mdi-timer" 
      class="px-5 py-3 ml-0">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>
      <v-row>
        <v-col cols="5">
          <v-card :loading="loading">
            <v-card-title class="justify-center display-2 font-weight-light pt-5">
              Ativos
            </v-card-title>
            <v-card-text>
              <validation-observer ref="validationObserverREF">
                <v-expansion-panels v-model="panel">
                  <draggable 
                    :list="agendamentosAtivos" 
                    group="people" 
                    @change="atualizaLista($event)" 
                    class="col-12"
                  >
                    <v-expansion-panel
                      v-for="item in agendamentosAtivos"
                      :key="item.id"
                      :class="inputsInvalidos.includes(item.id) && 'borderExpAA'"
                    >
                      <v-expansion-panel-header>
                        {{ item.titulo }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" class="pb-0">
                            <validation-provider v-slot="{ errors }" rules="required" :name="`${item.id}-recorrencia`">
                              <v-select
                                label="Recorrência"
                                v-model="item.recorrencia"
                                outlined
                                :items="['mensal', 'semanal', 'diario', 'hora', 'minuto']"
                                dense
                                :error-menssages="errors"
                                @change="limparParametros(item)"
                                @blur="checkAllValidations(item.id)"
                              >
                                <template v-slot:item="{ item }">
                                  {{item | formatTextRecorrencia}}
                                </template>
                                <template v-slot:selection="{ item }">
                                  {{item | formatTextRecorrencia}}
                                </template>
                              </v-select>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col v-if="item.recorrencia === 'mensal'" class="pt-0">
                            <validation-provider v-slot="{ errors }" rules="required|integer|between:1,30" :name="`${item.id}-dia`">
                              <v-text-field
                                label="Dia" 
                                outlined 
                                v-model="item.diaMes"
                                type="number"
                                dense
                                :error-messages="errors"
                                max="30"
                                min="0"
                                @blur="checkAllValidations(item.id)"
                              />
                            </validation-provider>
                          </v-col>
                          <v-col v-if="item.recorrencia === 'semanal'" class="pt-0">
                            <validation-provider v-slot="{ errors }" rules="required"  :name="`${item.id}-dia-semana`">
                              <v-select
                                label="Dia da Semana"
                                outlined
                                :items="diasSemana"
                                v-model="diasSemana[item.diaSemana]"
                                dense
                                @change="convertDiaSemana(item, $event)"
                                @blur="checkAllValidations(item.id)"
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </v-col>
                          <v-col v-if="['mensal', 'semanal', 'diario'].includes(item.recorrencia)" class="pt-0">
                            <validation-provider v-slot="{ errors }" rules="required" :name="`${item.id}-horario`">
                              <v-text-field
                                label="Horário"
                                outlined
                                v-model="item.time"
                                type="time"
                                dense
                                @blur="checkAllValidations(item.id)"
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </v-col>
                          <v-col v-if="item.recorrencia === 'hora'" class="pt-0">
                            <validation-provider v-slot="{ errors }" rules="required|integer|between:1,59" :name="`${item.id}-intervalo-hora`">
                              <v-text-field
                                label="Intervalo" 
                                outlined 
                                v-model="item.time"
                                type="number"
                                min="1"
                                max="59"
                                dense
                                @blur="checkAllValidations(item.id)"
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </v-col>
                          <v-col v-if="item.recorrencia === 'minuto'" class="pt-0">
                            <validation-provider v-slot="{ errors }" rules="required|integer|between:1,59" :name="`${item.id}-intervalo-minuto`">
                              <v-text-field
                                label="Intervalo" 
                                v-model="item.time"
                                outlined 
                                type="number"
                                min="1"
                                max="59"
                                dense
                                @blur="checkAllValidations(item.id)"
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>  
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </draggable>
                </v-expansion-panels>
              </validation-observer>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-container fill-height fluid v-if="!loading">
            <v-row class="flex-column">
              <v-col align="center" class="py-0">
                <v-icon x-large>
                  mdi-arrow-right-thick
                </v-icon>
              </v-col>
              <v-col align="center" class="py-0">
                <v-icon x-large>
                  mdi-arrow-left-thick
                </v-icon>
              </v-col>         
            </v-row>
          </v-container>
        </v-col>
        <v-col cols="5">
          <v-card :loading="loading">
            <v-card-title class="justify-center display-2 font-weight-light pt-5">
              Inativos
            </v-card-title>
            <v-card-text>
              <v-expansion-panels readonly>
                <draggable :list="agendamentosInativos" group="people" class="col-12">
                  <v-expansion-panel v-for="item in agendamentosInativos" :key="item.id" >
                    <v-expansion-panel-header expand-icon="" style="cursor:grab !important">
                      {{ item.titulo }}
                    </v-expansion-panel-header>
                  </v-expansion-panel>
                </draggable>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
export default {
  props: {
    agendamentosAtivos: {
      type: Array,
      default: () => []
    },
    agendamentosInativos: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },

  components: {
    draggable: () => import('vuedraggable')
  },

  mounted() {
    this.title = this.$route.name;
  },

  data: () => ({
    panel: [],
    title: "",
    diasSemana: ['domingo','segunda','terca','quarta','quinta','sexta','sabado'],
    inputsInvalidos: []
  }),

  methods: {
    closePanel() {
      this.panel = [];
    },

    convertDiaSemana(item, $event) {
      switch ($event){
        case "domingo" :
          item.diaSemana = 0;
          break;
        case "segunda" :
          item.diaSemana = 1;
          break;
        case "terca" :
          item.diaSemana = 2;
          break;
        case "quarta" :
          item.diaSemana = 3;
          break;
        case "quinta" :
          item.diaSemana = 4;
          break;
        case "sexta" :
          item.diaSemana = 5;
          break;
        case "sabado" :
          item.diaSemana = 6;
          break;
      }
    },

    atualizaLista($event) {
      if ($event.removed) {
        $event.removed.element.status = !$event.removed.element.status
      }
      if ($event.added) {
        $event.added.element.status = !$event.added.element.status
      }
    },

    limparParametros(item) {
      return item.time = item.diaMes = item.diaSemana = item.diasSemana = item.cronTime = "";
    },

    checkAllValidations(itemId) {
      const inputsNames = { input1: 'recorrencia', input2: 'dia', input3: 'dia-semana', input4: 'horario', input5: 'intervalo-hora', input6: 'intervalo-minuto' };

      for (const key in inputsNames) {
        const input = `${itemId}-${inputsNames[key]}`;
        this.$refs.validationObserverREF.validate(input).then(isValid => {
          this.inputsInvalidos = isValid ? this.inputsInvalidos.filter(item => item !== itemId) : [...new Set(this.inputsInvalidos.concat([itemId]))];
        });
      }
    }
  },

  filters: {
    formatTextRecorrencia(value) {
      switch (value) {
        case 'minuto':
          return 'A cada x minuto(s)';
        case 'hora':
          return 'A cada x hora(s)';
        default:
          return value;
      }
    }
  }
}
</script>

<style>
  .borderExpAA {
	  box-shadow: 0px 1px 7px red !important;
	  border-radius: .4rem !important;
  }
</style>